enum AccountMembershipRoles {
  OWNER = 0,
  REGULAR = 1,
}

export default AccountMembershipRoles
